module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Regular-cf2af4288c7c57c62e4d85ae5bc9cde0.woff";